export default {
  title: {
    loading: "Loading...",
    noOptions: "No options",
    select: "Select an option",
  },

  autoTitle: {
    fallback: "Select an option",
    noOptions: "No options available"
  }
}
